import { createDataSelectors } from "@app/modules/app.reducers";
import { User } from "@ea/shared_types/types";

export const usersDataSelectors = createDataSelectors<User>()("users");
